import { trackEvent } from "../lib/analytics";

export function CtaBlock() {
	return (
		<div className="my-10 p-6 bg-indigo-50 rounded-2xl border border-indigo-200">
			<h3 className="text-lg font-bold text-indigo-800 mb-2">
				背景除去もリサイズも、ブラウザで一括完了
			</h3>
			<p className="text-gray-700 mb-4 text-sm">
				<strong>しろぬきや</strong>
				は、AI背景除去＋EC各モール規格への自動リサイズを
				ブラウザ完結で行えるツールです。画像はサーバーに送信されないためプライバシー安全。
				無料で5枚/日まで利用できます。
			</p>
			<ul className="text-sm text-gray-600 mb-4 list-disc list-inside space-y-1">
				<li>Amazon: 1000×1000px以上・白背景</li>
				<li>楽天市場: 700×700px以上</li>
				<li>メルカリ: 1080×1080px推奨</li>
				<li>au PAYマーケット: 640×640px以上</li>
				<li>Qoo10: 800×800px推奨</li>
				<li>無料5枚/日・Pro月額¥500で無制限</li>
			</ul>
			<a
				href="https://shironukiya.fucina.casa"
				target="_blank"
				rel="noopener noreferrer"
				className="inline-block bg-indigo-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-indigo-500 transition"
				onClick={() =>
					trackEvent("click_cta", {
						cta_type: "blog_cta",
						destination_url: "https://shironukiya.fucina.casa",
					})
				}
			>
				しろぬきやを無料で使う →
			</a>
		</div>
	);
}
